import React from "react";
import { View as NView } from "native-base";
import type { IViewProps } from "native-base/lib/typescript/components/basic/View/types";

export const View: React.FC<IViewProps> = (props) => {
  return <NView {...props} />;
};

export default View;
